









































































































import Vue from "vue";
import { mapGetters } from "vuex";
import { ROUTES } from "@/constants/routes";
export default Vue.extend({
  name: "CategoryBubbles",
  computed: {
    ...mapGetters(["getFacetsSelected"]),
  },
  methods: {
    clickCategory(category: string): void {
      this.$store.dispatch("selectFacets", category);
      this.$store.dispatch("changeShowMainComponent", {
        showHome: false,
        showRes: true,
      });
      const query = this.getFacetsSelected.toString();
      this.$router.push({
        path: ROUTES.SEARCH.path,
        query: { appCategories: query },
      });
    },
  },
});
